import { render, staticRenderFns } from "./DataShow.vue?vue&type=template&id=751d6e3d&scoped=true&"
import script from "./DataShow.vue?vue&type=script&lang=js&"
export * from "./DataShow.vue?vue&type=script&lang=js&"
import style0 from "./DataShow.vue?vue&type=style&index=0&id=751d6e3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751d6e3d",
  null
  
)

export default component.exports